// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wordduel-container {
  position: fixed;
  top: 50%; left: 50%; transform: translate(-50%, -50%);
  width: 95%; max-width: 400px; height: 90vh;
  background: #121212;
  border: 4px solid #2c3e50;
  border-radius: 8px;
  display: flex; flex-direction: column;
  padding: 15px; box-sizing: border-box;
  color: #e0e0e0; font-family: 'Courier New', Courier, monospace;
  z-index: 6000;
  color-scheme: dark; /* Подсказка браузеру использовать темные системные элементы */
}

/* Лента истории */
.wd-history {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 15px;
  padding: 10px;
  background: rgba(0,0,0,0.3);
  border-radius: 4px;
}

.wd-history * {
  touch-action: pan-y;
}

/* Полностью обновленный блок стилизации скроллбара */

/* Ширина и наличие скроллбара */
.wd-history::-webkit-scrollbar {
  width: 6px !important; /* Немного увеличим для надежности теста */
  display: block !important;
}

/* Фон дорожки — сделаем его явно темным, а не прозрачным */
.wd-history::-webkit-scrollbar-track {
  background-color: #000000 !important;
  border-radius: 10px !important;
}

/* Сам ползунок */
.wd-history::-webkit-scrollbar-thumb {
  background-color: #334155 !important; /* Твой сине-серый цвет */
  border-radius: 10px !important;
  border: 1px solid #000000 !important; /* Отступ внутри дорожки, чтобы не слипалось */
}

/* Цвет ползунка при наведении */
.wd-history::-webkit-scrollbar-thumb:hover {
  background-color: #fbbf24 !important; /* Твой золотой цвет */
}

/* Для Firefox */
.wd-history {
  scrollbar-width: thin !important;
  scrollbar-color: #334155 #000000 !important;
}

/* Убираем лишние отступы у истории, чтобы скроллбар прилегал плотнее к краю */
.wd-history {
  padding-right: 8px;
}

.wd-bubble {
  max-width: 85%;
  padding: 8px 12px;
  border-radius: 4px;
  position: relative;
}

.wd-bubble.bot {
  align-self: flex-start;
  background: #1e272e;
  border-left: 3px solid #f39c12;
}

.wd-bubble.player {
  align-self: flex-end;
  background: #2c3e50;
  border-right: 3px solid #27ae60;
  text-align: right;
}

.wd-word {
  font-size: 18px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.wd-letter-hint {
  color: #f39c12;
  font-weight: 900;
  text-decoration: underline;
}

/* Пузырек игрока: убираем определение (оно там не нужно по логике) */
.wd-bubble.player .wd-definition {
  display: none;
}

/* Полупрозрачность для отправленного, но еще не проверенного слова */
.wd-bubble.pending {
  opacity: 0.5;
  filter: grayscale(0.5);
  border-style: dashed; /* Пунктирная рамка для индикации "в процессе" */
}

/* Пузырек ошибки */
.wd-bubble.error {
  align-self: flex-end;
  background: #c0392b;
  border-right: 3px solid #7f1d1d;
  color: #fff;
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
  animation: wd-shake 0.4s ease-in-out;
}

@keyframes wd-shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

/* Стили для определений под словами */
.wd-definition {
  font-size: 11px;
  line-height: 1.2;
  margin-top: 4px;
  opacity: 0.7;
  font-family: sans-serif; /* Для лучшей читаемости мелкого текста */

  /* Ограничение в 4 строки */
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Стилизация определения бота (сделаем еще чуть изящнее) */
.bot .wd-definition {
  border-top: 1px solid rgba(255,255,255,0.1);
  padding-top: 4px;
  color: #94a3b8;
}

/* Анимация индикатора печати */
.wd-typing-dots {
  display: flex;
  gap: 4px;
  padding: 10px;
  align-self: flex-start;
  background: #1e272e;
  border-radius: 4px;
  margin-bottom: 12px;
}

.wd-dot {
  width: 6px;
  height: 6px;
  background: #f39c12;
  border-radius: 50%;
  animation: wd-blink 1.4s infinite both;
}

.wd-dot:nth-child(2) { animation-delay: 0.2s; }
.wd-dot:nth-child(3) { animation-delay: 0.4s; }

@keyframes wd-blink {
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
}

/* Обертка для инпута и крестика (как в Словоделе) */
.wd-input-wrapper {
  position: relative;
  flex: 1 1;
  display: flex;
  align-items: stretch;
}

.wd-input {
  width: 100%;
  height: 56px;
  background: rgba(0,0,0,0.4);
  border: 2px solid #334155;
  color: #fff;
  font-size: 22px;
  font-family: inherit;
  padding: 0 45px 0 15px; /* Отступ справа увеличен под крестик */
  text-transform: uppercase;
  border-radius: 8px;
  letter-spacing: 2px;
  outline: none;
  transition: all 0.2s;
  box-sizing: border-box;
}

.wd-input:focus {
  border-color: #fbbf24;
  background: rgba(0,0,0,0.6);
}

/* Визуальная индикация блокировки (когда бот "думает") */
.wd-input.locked {
  background: rgba(0,0,0,0.6);
  opacity: 0.7;
}

/* Маленький крестик внутри инпута */
.wd-input-clear-x {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.3); /* Тусклый в покое */
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.2s;
  z-index: 5;
}

.wd-input-clear-x:hover, .wd-input-clear-x:active {
  color: #ef4444; /* Краснеет при взаимодействии */
  transform: translateY(-50%) scale(1.1);
}

/* Контейнер всей области ввода */
.wd-input-area {
  display: flex;
  gap: 10px;
  margin-top: auto;
  padding-top: 15px;
  align-items: stretch;
}

/* Обертка для инпута и внутреннего крестика */
.wd-input-wrapper {
  position: relative;
  flex: 1 1;
  display: flex;
}

.wd-input {
  width: 100%;
  height: 56px;
  background: rgba(0, 0, 0, 0.4);
  border: 2px solid #334155;
  color: #fff;
  font-size: 22px;
  font-family: inherit;
  /* Важно: большой отступ справа, чтобы текст не заходил под крестик */
  padding: 0 45px 0 15px;
  text-transform: uppercase;
  border-radius: 8px;
  letter-spacing: 2px;
  outline: none;
  transition: all 0.2s;
  box-sizing: border-box;
}

.wd-input:focus {
  border-color: #fbbf24;
  background: rgba(0,0,0,0.6);
}

/* Визуальная индикация блокировки (когда бот "думает") */
.wd-input.locked {
  background: rgba(0,0,0,0.6);
  opacity: 0.7;
}

/* Тот самый крестик ВНУТРИ инпута */
.wd-input-clear-x {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(255, 255, 255, 0.3);
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.2s;
  z-index: 5;
}

.wd-input-clear-x:hover, .wd-input-clear-x:active {
  color: #ef4444;
}

/* Квадратная кнопка отправки (стиль Словодела) */
.wd-submit-btn-square {
  width: 56px;
  height: 56px;
  background: #fbbf24;
  color: #0f172a;
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  box-shadow: 0 4px 0 #b45309;
  flex-shrink: 0;
  transition: all 0.1s;
}

.wd-submit-btn-square:active {
  transform: translateY(2px);
  box-shadow: 0 2px 0 #b45309;
}

.wd-submit-btn-square:disabled {
  opacity: 0.6;
  filter: grayscale(1);
}

/* Таймер */
.wd-timer-bar {
  height: 4px; background: #2ecc71;
  transition: width 0.1s linear, background 0.5s;
  margin-top: 5px;
}
.wd-timer-bar.danger { background: #e74c3c; }

.wd-next-letter-banner {
  text-align: center;
  font-size: 14px;
  color: #7f8c8d;
  margin-bottom: 5px;
}
.wd-target {
  color: #f39c12; font-size: 24px; font-weight: 900;
}

/* --- СТРОКА С ОШИБКОЙ --- */
.wd-rejected-row {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  /* Увеличили отступ между плашкой и словом */
  gap: 15px;
  margin-bottom: 12px;
  animation: wd-fade-in 0.3s ease-out;
}

/* Красная плашка ошибки - УВЕЛИЧЕНА */
.wd-error-badge {
  background: #c0392b;
  color: #fff;
  /* Увеличен шрифт */
  font-size: 13px;
  /* Увеличены внутренние отступы */
  padding: 8px 14px;
  border-radius: 6px;
  font-weight: 900;
  text-transform: uppercase;
  white-space: nowrap;
  box-shadow: 0 3px 6px rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  position: relative;
  letter-spacing: 0.5px;
}

/* Указатель от плашки к слову (чуть больше) */
.wd-error-badge::after {
  content: '';
  position: absolute;
  right: -6px;
  top: 50%;
  transform: translateY(-50%);
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 7px solid #c0392b;
}

/* Стиль неверного слова */
.wd-bubble.rejected {
  background: #3d1b1b !important;
  border-right: 4px solid #7f1d1d !important;
  opacity: 0.9;
  margin-bottom: 0;
}

.wd-bubble.rejected .wd-word {
  text-decoration: line-through;
  color: #b0b0b0;
  /* Шрифт чуть меньше, чтобы плашка на его фоне выглядела массивнее */
  font-size: 17px;
}

@keyframes wd-fade-in {
  from { opacity: 0; transform: translateX(10px); }
  to { opacity: 1; transform: translateX(0); }
}

/* Оптимизация скроллбара для длинной истории */
.wd-history::-webkit-scrollbar {
  width: 4px;
}
.wd-history::-webkit-scrollbar-thumb {
  background: #334155;
  border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/arcade/games/wordduel/WordDuel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ,EAAE,SAAS,EAAE,gCAAgC;EACrD,UAAU,EAAE,gBAAgB,EAAE,YAAY;EAC1C,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa,EAAE,sBAAsB;EACrC,aAAa,EAAE,sBAAsB;EACrC,cAAc,EAAE,8CAA8C;EAC9D,aAAa;EACb,kBAAkB,EAAE,8DAA8D;AACpF;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qDAAqD;;AAErD,gCAAgC;AAChC;EACE,qBAAqB,EAAE,0CAA0C;EACjE,yBAAyB;AAC3B;;AAEA,2DAA2D;AAC3D;EACE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,oCAAoC,EAAE,yBAAyB;EAC/D,8BAA8B;EAC9B,oCAAoC,EAAE,8CAA8C;AACtF;;AAEA,gCAAgC;AAChC;EACE,oCAAoC,EAAE,sBAAsB;AAC9D;;AAEA,gBAAgB;AAChB;EACE,gCAAgC;EAChC,2CAA2C;AAC7C;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,qEAAqE;AACrE;EACE,aAAa;AACf;;AAEA,qEAAqE;AACrE;EACE,YAAY;EACZ,sBAAsB;EACtB,oBAAoB,EAAE,gDAAgD;AACxE;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;EACnC,MAAM,0BAA0B,EAAE;AACpC;;AAEA,sCAAsC;AACtC;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,uBAAuB,EAAE,yCAAyC;;EAElE,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,2DAA2D;AAC3D;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,uBAAuB,qBAAqB,EAAE;AAC9C,uBAAuB,qBAAqB,EAAE;;AAE9C;EACE,gBAAgB,UAAU,EAAE;EAC5B,MAAM,UAAU,EAAE;AACpB;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,sBAAsB,EAAE,uCAAuC;EAC/D,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,+BAA+B,EAAE,oBAAoB;EACrD,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,cAAc,EAAE,gCAAgC;EAChD,sCAAsC;AACxC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,qEAAqE;EACrE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,+BAA+B;EAC/B,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,WAAW,EAAE,mBAAmB;EAChC,8CAA8C;EAC9C,eAAe;AACjB;AACA,uBAAuB,mBAAmB,EAAE;;AAE5C;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc,EAAE,eAAe,EAAE,gBAAgB;AACnD;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,4CAA4C;EAC5C,SAAS;EACT,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,iCAAiC;EACjC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B;EAC9B,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,oEAAoE;EACpE,eAAe;AACjB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,+CAA+C;AAC/C;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".wordduel-container {\r\n  position: fixed;\r\n  top: 50%; left: 50%; transform: translate(-50%, -50%);\r\n  width: 95%; max-width: 400px; height: 90vh;\r\n  background: #121212;\r\n  border: 4px solid #2c3e50;\r\n  border-radius: 8px;\r\n  display: flex; flex-direction: column;\r\n  padding: 15px; box-sizing: border-box;\r\n  color: #e0e0e0; font-family: 'Courier New', Courier, monospace;\r\n  z-index: 6000;\r\n  color-scheme: dark; /* Подсказка браузеру использовать темные системные элементы */\r\n}\r\n\r\n/* Лента истории */\r\n.wd-history {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n  margin-bottom: 15px;\r\n  padding: 10px;\r\n  background: rgba(0,0,0,0.3);\r\n  border-radius: 4px;\r\n}\r\n\r\n.wd-history * {\r\n  touch-action: pan-y;\r\n}\r\n\r\n/* Полностью обновленный блок стилизации скроллбара */\r\n\r\n/* Ширина и наличие скроллбара */\r\n.wd-history::-webkit-scrollbar {\r\n  width: 6px !important; /* Немного увеличим для надежности теста */\r\n  display: block !important;\r\n}\r\n\r\n/* Фон дорожки — сделаем его явно темным, а не прозрачным */\r\n.wd-history::-webkit-scrollbar-track {\r\n  background-color: #000000 !important;\r\n  border-radius: 10px !important;\r\n}\r\n\r\n/* Сам ползунок */\r\n.wd-history::-webkit-scrollbar-thumb {\r\n  background-color: #334155 !important; /* Твой сине-серый цвет */\r\n  border-radius: 10px !important;\r\n  border: 1px solid #000000 !important; /* Отступ внутри дорожки, чтобы не слипалось */\r\n}\r\n\r\n/* Цвет ползунка при наведении */\r\n.wd-history::-webkit-scrollbar-thumb:hover {\r\n  background-color: #fbbf24 !important; /* Твой золотой цвет */\r\n}\r\n\r\n/* Для Firefox */\r\n.wd-history {\r\n  scrollbar-width: thin !important;\r\n  scrollbar-color: #334155 #000000 !important;\r\n}\r\n\r\n/* Убираем лишние отступы у истории, чтобы скроллбар прилегал плотнее к краю */\r\n.wd-history {\r\n  padding-right: 8px;\r\n}\r\n\r\n.wd-bubble {\r\n  max-width: 85%;\r\n  padding: 8px 12px;\r\n  border-radius: 4px;\r\n  position: relative;\r\n}\r\n\r\n.wd-bubble.bot {\r\n  align-self: flex-start;\r\n  background: #1e272e;\r\n  border-left: 3px solid #f39c12;\r\n}\r\n\r\n.wd-bubble.player {\r\n  align-self: flex-end;\r\n  background: #2c3e50;\r\n  border-right: 3px solid #27ae60;\r\n  text-align: right;\r\n}\r\n\r\n.wd-word {\r\n  font-size: 18px;\r\n  font-weight: 900;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n.wd-letter-hint {\r\n  color: #f39c12;\r\n  font-weight: 900;\r\n  text-decoration: underline;\r\n}\r\n\r\n/* Пузырек игрока: убираем определение (оно там не нужно по логике) */\r\n.wd-bubble.player .wd-definition {\r\n  display: none;\r\n}\r\n\r\n/* Полупрозрачность для отправленного, но еще не проверенного слова */\r\n.wd-bubble.pending {\r\n  opacity: 0.5;\r\n  filter: grayscale(0.5);\r\n  border-style: dashed; /* Пунктирная рамка для индикации \"в процессе\" */\r\n}\r\n\r\n/* Пузырек ошибки */\r\n.wd-bubble.error {\r\n  align-self: flex-end;\r\n  background: #c0392b;\r\n  border-right: 3px solid #7f1d1d;\r\n  color: #fff;\r\n  font-size: 13px;\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n  animation: wd-shake 0.4s ease-in-out;\r\n}\r\n\r\n@keyframes wd-shake {\r\n  0%, 100% { transform: translateX(0); }\r\n  25% { transform: translateX(-5px); }\r\n  75% { transform: translateX(5px); }\r\n}\r\n\r\n/* Стили для определений под словами */\r\n.wd-definition {\r\n  font-size: 11px;\r\n  line-height: 1.2;\r\n  margin-top: 4px;\r\n  opacity: 0.7;\r\n  font-family: sans-serif; /* Для лучшей читаемости мелкого текста */\r\n\r\n  /* Ограничение в 4 строки */\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 4;\r\n  line-clamp: 4;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n/* Стилизация определения бота (сделаем еще чуть изящнее) */\r\n.bot .wd-definition {\r\n  border-top: 1px solid rgba(255,255,255,0.1);\r\n  padding-top: 4px;\r\n  color: #94a3b8;\r\n}\r\n\r\n/* Анимация индикатора печати */\r\n.wd-typing-dots {\r\n  display: flex;\r\n  gap: 4px;\r\n  padding: 10px;\r\n  align-self: flex-start;\r\n  background: #1e272e;\r\n  border-radius: 4px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.wd-dot {\r\n  width: 6px;\r\n  height: 6px;\r\n  background: #f39c12;\r\n  border-radius: 50%;\r\n  animation: wd-blink 1.4s infinite both;\r\n}\r\n\r\n.wd-dot:nth-child(2) { animation-delay: 0.2s; }\r\n.wd-dot:nth-child(3) { animation-delay: 0.4s; }\r\n\r\n@keyframes wd-blink {\r\n  0%, 80%, 100% { opacity: 0; }\r\n  40% { opacity: 1; }\r\n}\r\n\r\n/* Обертка для инпута и крестика (как в Словоделе) */\r\n.wd-input-wrapper {\r\n  position: relative;\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: stretch;\r\n}\r\n\r\n.wd-input {\r\n  width: 100%;\r\n  height: 56px;\r\n  background: rgba(0,0,0,0.4);\r\n  border: 2px solid #334155;\r\n  color: #fff;\r\n  font-size: 22px;\r\n  font-family: inherit;\r\n  padding: 0 45px 0 15px; /* Отступ справа увеличен под крестик */\r\n  text-transform: uppercase;\r\n  border-radius: 8px;\r\n  letter-spacing: 2px;\r\n  outline: none;\r\n  transition: all 0.2s;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.wd-input:focus {\r\n  border-color: #fbbf24;\r\n  background: rgba(0,0,0,0.6);\r\n}\r\n\r\n/* Визуальная индикация блокировки (когда бот \"думает\") */\r\n.wd-input.locked {\r\n  background: rgba(0,0,0,0.6);\r\n  opacity: 0.7;\r\n}\r\n\r\n/* Маленький крестик внутри инпута */\r\n.wd-input-clear-x {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: rgba(255, 255, 255, 0.3); /* Тусклый в покое */\r\n  cursor: pointer;\r\n  width: 36px;\r\n  height: 36px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 18px;\r\n  transition: all 0.2s;\r\n  z-index: 5;\r\n}\r\n\r\n.wd-input-clear-x:hover, .wd-input-clear-x:active {\r\n  color: #ef4444; /* Краснеет при взаимодействии */\r\n  transform: translateY(-50%) scale(1.1);\r\n}\r\n\r\n/* Контейнер всей области ввода */\r\n.wd-input-area {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: auto;\r\n  padding-top: 15px;\r\n  align-items: stretch;\r\n}\r\n\r\n/* Обертка для инпута и внутреннего крестика */\r\n.wd-input-wrapper {\r\n  position: relative;\r\n  flex: 1;\r\n  display: flex;\r\n}\r\n\r\n.wd-input {\r\n  width: 100%;\r\n  height: 56px;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  border: 2px solid #334155;\r\n  color: #fff;\r\n  font-size: 22px;\r\n  font-family: inherit;\r\n  /* Важно: большой отступ справа, чтобы текст не заходил под крестик */\r\n  padding: 0 45px 0 15px;\r\n  text-transform: uppercase;\r\n  border-radius: 8px;\r\n  letter-spacing: 2px;\r\n  outline: none;\r\n  transition: all 0.2s;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.wd-input:focus {\r\n  border-color: #fbbf24;\r\n  background: rgba(0,0,0,0.6);\r\n}\r\n\r\n/* Визуальная индикация блокировки (когда бот \"думает\") */\r\n.wd-input.locked {\r\n  background: rgba(0,0,0,0.6);\r\n  opacity: 0.7;\r\n}\r\n\r\n/* Тот самый крестик ВНУТРИ инпута */\r\n.wd-input-clear-x {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: rgba(255, 255, 255, 0.3);\r\n  cursor: pointer;\r\n  width: 36px;\r\n  height: 36px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 18px;\r\n  transition: all 0.2s;\r\n  z-index: 5;\r\n}\r\n\r\n.wd-input-clear-x:hover, .wd-input-clear-x:active {\r\n  color: #ef4444;\r\n}\r\n\r\n/* Квадратная кнопка отправки (стиль Словодела) */\r\n.wd-submit-btn-square {\r\n  width: 56px;\r\n  height: 56px;\r\n  background: #fbbf24;\r\n  color: #0f172a;\r\n  border: none;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n  box-shadow: 0 4px 0 #b45309;\r\n  flex-shrink: 0;\r\n  transition: all 0.1s;\r\n}\r\n\r\n.wd-submit-btn-square:active {\r\n  transform: translateY(2px);\r\n  box-shadow: 0 2px 0 #b45309;\r\n}\r\n\r\n.wd-submit-btn-square:disabled {\r\n  opacity: 0.6;\r\n  filter: grayscale(1);\r\n}\r\n\r\n/* Таймер */\r\n.wd-timer-bar {\r\n  height: 4px; background: #2ecc71;\r\n  transition: width 0.1s linear, background 0.5s;\r\n  margin-top: 5px;\r\n}\r\n.wd-timer-bar.danger { background: #e74c3c; }\r\n\r\n.wd-next-letter-banner {\r\n  text-align: center;\r\n  font-size: 14px;\r\n  color: #7f8c8d;\r\n  margin-bottom: 5px;\r\n}\r\n.wd-target {\r\n  color: #f39c12; font-size: 24px; font-weight: 900;\r\n}\r\n\r\n/* --- СТРОКА С ОШИБКОЙ --- */\r\n.wd-rejected-row {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  /* Увеличили отступ между плашкой и словом */\r\n  gap: 15px;\r\n  margin-bottom: 12px;\r\n  animation: wd-fade-in 0.3s ease-out;\r\n}\r\n\r\n/* Красная плашка ошибки - УВЕЛИЧЕНА */\r\n.wd-error-badge {\r\n  background: #c0392b;\r\n  color: #fff;\r\n  /* Увеличен шрифт */\r\n  font-size: 13px;\r\n  /* Увеличены внутренние отступы */\r\n  padding: 8px 14px;\r\n  border-radius: 6px;\r\n  font-weight: 900;\r\n  text-transform: uppercase;\r\n  white-space: nowrap;\r\n  box-shadow: 0 3px 6px rgba(0,0,0,0.4);\r\n  display: flex;\r\n  align-items: center;\r\n  position: relative;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n/* Указатель от плашки к слову (чуть больше) */\r\n.wd-error-badge::after {\r\n  content: '';\r\n  position: absolute;\r\n  right: -6px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  border-top: 6px solid transparent;\r\n  border-bottom: 6px solid transparent;\r\n  border-left: 7px solid #c0392b;\r\n}\r\n\r\n/* Стиль неверного слова */\r\n.wd-bubble.rejected {\r\n  background: #3d1b1b !important;\r\n  border-right: 4px solid #7f1d1d !important;\r\n  opacity: 0.9;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.wd-bubble.rejected .wd-word {\r\n  text-decoration: line-through;\r\n  color: #b0b0b0;\r\n  /* Шрифт чуть меньше, чтобы плашка на его фоне выглядела массивнее */\r\n  font-size: 17px;\r\n}\r\n\r\n@keyframes wd-fade-in {\r\n  from { opacity: 0; transform: translateX(10px); }\r\n  to { opacity: 1; transform: translateX(0); }\r\n}\r\n\r\n/* Оптимизация скроллбара для длинной истории */\r\n.wd-history::-webkit-scrollbar {\r\n  width: 4px;\r\n}\r\n.wd-history::-webkit-scrollbar-thumb {\r\n  background: #334155;\r\n  border-radius: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
